'use client';

import React, { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/actions/authActions';

// Composants importés
import Sidebar from '../common/Sidebar';
import Navbar from '../common/Navbar';
import NotificationCenter from '../common/NotificationCenter';

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Navigation spécifique à l'administration
  const adminNavItems = [
    { label: 'Tableau de bord admin', path: '/admin', icon: 'dashboard' },
    { label: 'Gestion utilisateurs', path: '/admin/users', icon: 'people' },
    { label: 'Invitations', path: '/admin/users/invitations', icon: 'mail' },
    { label: 'Soumissions', path: '/admin/submissions', icon: 'inbox' },
    { label: 'Commandes', path: '/admin/orders', icon: 'shopping_cart' },
    { label: 'Alertes email', path: '/admin/settings/alerts', icon: 'notifications' },
    { label: 'Format des fichiers', path: '/admin/settings/filenames', icon: 'drive_file_rename_outline' },
    { label: 'Retour à l\'app', path: '/dashboard', icon: 'arrow_back' },
  ];

  return (
    <div className="app-container admin-theme">
      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        items={adminNavItems}
        user={user}
        onLogout={handleLogout}
        adminMode={true}
      />

      <div className="main-content">
        <Navbar 
          onMenuClick={toggleSidebar}
          user={user}
          onLogout={handleLogout}
          adminMode={true}
          title="Administration"
        />

        <div className="page-container">
          <Outlet />
        </div>

        <NotificationCenter />
      </div>
    </div>
  );
};

export default AdminLayout;